// Color constants
export const COLORS = {
  primary: "#F37F09",
  blue: "#105D8E",
  error: "#e53e3e",
  white: "#fff",
  black: "#000",
  gray: {
    light: "#e0e0e0",
    medium: "#888",
    dark: "#222",
    darker: "#111",
  },
  text: {
    light: "#eee",
    medium: "#aaa",
  },
};

// Size constants
export const SIZES = {
  headerHeight: 56,
  logoWidth: 360,
  searchMaxWidth: 600,
  iconSize: {
    small: 20,
    medium: 22,
    large: 28,
  },
  spacing: {
    xs: 8,
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 64,
  },
  borderRadius: {
    sm: 6,
    md: 16,
    lg: 32,
  },
};

// Locale configurations - Active locales shown in language selector
// Add new locales here when translations are ready
export const LOCALES = [
  {
    code: "en-CA",
    label: "English (CA)",
    nativeName: "English",
    countryCode: "CA",
    flag: "CA",
  },
  {
    code: "en-US",
    label: "English (US)",
    nativeName: "English",
    countryCode: "US",
    flag: "US",
  },
  {
    code: "fr-CA",
    label: "Français (CA)",
    nativeName: "Français",
    countryCode: "CA",
    flag: "CA",
  },
  {
    code: "es-MX",
    label: "Español (MX)",
    nativeName: "Español",
    countryCode: "MX",
    flag: "MX",
  },
  // Uncomment when translations are ready:
  // {
  //   code: "es-ES",
  //   label: "Español",
  //   nativeName: "Español",
  //   countryCode: "ES",
  //   flag: "ES",
  // },
  // {
  //   code: "de-DE",
  //   label: "Deutsch",
  //   nativeName: "Deutsch",
  //   countryCode: "DE",
  //   flag: "DE",
  // },
  // {
  //   code: "it-IT",
  //   label: "Italiano",
  //   nativeName: "Italiano",
  //   countryCode: "IT",
  //   flag: "IT",
  // },
  // {
  //   code: "pt-BR",
  //   label: "Português",
  //   nativeName: "Português",
  //   countryCode: "BR",
  //   flag: "BR",
  // },
  // {
  //   code: "ar-SA",
  //   label: "العربية",
  //   nativeName: "العربية",
  //   countryCode: "SA",
  //   flag: "SA",
  //   rtl: true,
  // },
  // {
  //   code: "zh-CN",
  //   label: "中文",
  //   nativeName: "中文",
  //   countryCode: "CN",
  //   flag: "CN",
  // },
];

// All available locales (for admin/settings - shows upcoming languages)
export const ALL_LOCALES = [
  { code: "en-CA", label: "English (Canada)", available: true },
  { code: "en-US", label: "English (US)", available: true },
  { code: "en-GB", label: "English (UK)", available: true },
  { code: "fr-CA", label: "French (Canada)", available: true },
  { code: "fr-FR", label: "French (France)", available: true },
  { code: "es-ES", label: "Spanish (Spain)", available: false },
  { code: "es-MX", label: "Spanish (Mexico)", available: true },
  { code: "de-DE", label: "German", available: false },
  { code: "it-IT", label: "Italian", available: false },
  { code: "pt-BR", label: "Portuguese (Brazil)", available: false },
  { code: "ar-SA", label: "Arabic", available: false },
  { code: "zh-CN", label: "Chinese (Simplified)", available: false },
];

// Zip/postal code validation patterns
export const ZIP_PATTERNS = [
  /^\d{5}(-\d{4})?$/, // US (with optional ZIP+4)
  /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/, // Canada
  /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|GIR ?0AA)$/, // UK
  /^\d{4}$/, // Australia
  /^\d{5}$/, // Mexico/Germany/France (5 digits)
  /^\d{6}$/, // India
];

// API configuration
export const API = {
  nominatimBaseUrl: "https://nominatim.openstreetmap.org",
  userAgent: "CompareMechanicApp/1.0 (contact@example.com)",
};

// Error messages
export const ERROR_MESSAGES = {
  noGeolocation: "Geolocation is not supported by your browser.",
  permissionDenied:
    "Location access denied. Please enter your location manually.",
  positionUnavailable: "Location unavailable. Check your network or try again.",
  timeout: "Location request timed out. Please retry.",
  defaultLocation:
    "Unable to access your location. Please allow location access.",
  noPostcode: "Could not determine your postal code from your location.",
  apiError: "Error retrieving postal code from location.",
  emptyZip: "Please enter a zip or postal code.",
  invalidZip: "Please enter a valid zip or postal code.",
};
